import React, { useCallback, useEffect, useState } from "react";
import { Link } from "@mui/material";

import { ServiceAPI } from "../../../api/service";

export interface IAppVersionData {
  version: string;
}

const UpdateVersion: React.FC = () => {
  const [isLatestVersion, setIsLatestVersion] = useState(false);

  const checkVersion = useCallback(async () => {
    try {
      const currentVersion = localStorage.getItem("APP_VERSION");
      const res = await ServiceAPI.getAppVersion();

      if (!currentVersion) {
        const newVersion: IAppVersionData = {
          version: res.version,
        };
        localStorage.setItem("APP_VERSION", JSON.stringify(newVersion));
        return;
      }

      const storedVersion: IAppVersionData = JSON.parse(currentVersion);
      if (storedVersion.version !== res.version) {
        setIsLatestVersion(true);
      }
    } catch (error) {
      console.error("Error checking version:", error);
    }
  }, []);

  useEffect(() => {
    checkVersion();
  }, [checkVersion]);

  const handleUpdateVersion = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    try {
      if ("caches" in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map((key) => caches.delete(key)));
      }

      const res = await fetch("/meta.json");
      const data = await res.json();

      const newVersion: IAppVersionData = { version: data.version };
      localStorage.setItem("APP_VERSION", JSON.stringify(newVersion));

      window.location.reload();
    } catch (error) {
      console.error("Error updating version", error);
    }
  };
  return (
    <div>
      {isLatestVersion && (
        <Link
          color="inherit"
          sx={{
            display: "block",
            color: "white",
            padding: "10px",
            animation: "blink 1s linear infinite",
            textAlign: "center",
          }}
          href="./#"
          onClick={handleUpdateVersion}
        >
          Update version
        </Link>
      )}
    </div>
  );
};

export default UpdateVersion;
